import { Card, Table, Tag, Typography } from 'antd';
import { useTrading } from '../context/TradingContext';

const { Title } = Typography;

export default function History() {
  const { portfolio } = useTrading();

  const columns = [
    { title: 'Time', dataIndex: 'timestamp', key: 'timestamp',
      render: (v: string) => new Date(v).toLocaleString() },
    { title: 'Symbol', dataIndex: 'symbol', key: 'symbol',
      render: (s: string) => <strong style={{ fontFamily: 'monospace' }}>{s}</strong> },
    { title: 'Side', dataIndex: 'side', key: 'side',
      render: (s: string) => <Tag color={s === 'buy' ? 'green' : 'red'}>{s.toUpperCase()}</Tag> },
    { title: 'Shares', dataIndex: 'shares', key: 'shares', align: 'right' as const },
    { title: 'Price', dataIndex: 'price', key: 'price', align: 'right' as const,
      render: (v: number) => `$${v.toFixed(2)}` },
    { title: 'Total', dataIndex: 'total', key: 'total', align: 'right' as const,
      render: (v: number, row: { side: string }) => (
        <span style={{ color: row.side === 'buy' ? '#ff4d4f' : '#52c41a' }}>
          {row.side === 'buy' ? '-' : '+'}${v.toLocaleString('en', { minimumFractionDigits: 2 })}
        </span>
      ) },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Title level={3} style={{ marginBottom: 24 }}>Trade History</Title>
      <Card>
        {portfolio.trades.length === 0
          ? <Typography.Text type="secondary">No trades yet. Go to Market to place your first trade.</Typography.Text>
          : <Table
              dataSource={portfolio.trades}
              columns={columns}
              rowKey="id"
              size="small"
              pagination={{ pageSize: 20 }}
            />
        }
      </Card>
    </div>
  );
}
